import React, { useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
} from "reactstrap";
import classnames from "classnames";
import ComplimentryAll from "../component/ComplimentryAll";
import ComplimentryGroupItem from "../component/ComplimentryGroupItem";

const ComplimentryLogs = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Complimentary Logs" pageTitle="Logs" />

        <div
          style={{
            background: "#ffffff",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            border: "1px solid #eee",
            overflow: "hidden",
          }}
        >
          {/* Modern Tab Navigation */}
          <div
            style={{
              borderBottom: "2px solid #f0f0f0",
              padding: "0 1.5rem",
              background: "#fafafa",
            }}
          >
            <Nav tabs className="border-0">
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "1",
                    "border-0": true,
                    "px-4": true,
                    "py-3": true,
                  })}
                  onClick={() => toggle("1")}
                  style={{
                    cursor: "pointer",
                    fontWeight: activeTab === "1" ? "600" : "500",
                    color: activeTab === "1" ? "#0d6efd" : "#6c757d",
                    borderBottom:
                      activeTab === "1" ? "3px solid #0d6efd" : "none",
                    background: "transparent",
                    transition: "all 0.3s ease",
                  }}
                >
                  <i className="bx bx-list-ul me-2"></i>
                  Complimentary Logs
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "2",
                    "border-0": true,
                    "px-4": true,
                    "py-3": true,
                  })}
                  onClick={() => toggle("2")}
                  style={{
                    cursor: "pointer",
                    fontWeight: activeTab === "2" ? "600" : "500",
                    color: activeTab === "2" ? "#0d6efd" : "#6c757d",
                    borderBottom:
                      activeTab === "2" ? "3px solid #0d6efd" : "none",
                    background: "transparent",
                    transition: "all 0.3s ease",
                  }}
                >
                  <i className="bx bx-group me-2"></i>
                  Group by Items
                </NavLink>
              </NavItem>
            </Nav>
          </div>

          {/* Tab Content */}
          <TabContent activeTab={activeTab} className="p-0">
            <TabPane tabId="1">
              <ComplimentryAll />
            </TabPane>
            <TabPane tabId="2">
              <ComplimentryGroupItem />
            </TabPane>
          </TabContent>
        </div>
      </div>
    </Container>
  );
};

export default ComplimentryLogs;
